if (!customElements.get('collection-sorting')) {
  class CollectionSorting extends HTMLElement {
    constructor() {
      super();
      this.filterData = [];
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
      this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    /**
     * onSubmitHandler
     * @param {Object} event
     */
    onSubmitHandler(event) {
      event.preventDefault();
      const formData = new FormData(event.target.closest('form'));
      let formFilterData = new URLSearchParams(formData);

      // Get active filter list
      const activeFilterList = () => {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const filtersList = {};

        for (const [key, value] of params.entries()) {
          if (key.includes('filter')) filtersList[key] = value;
        }

        return filtersList;
      };

      // Get the complete search string
      const searchParams = formFilterData.toString();
      this.renderPage(searchParams, event, true, activeFilterList());
    }

    /**
     * onActiveFilterClick
     * @param {Object} event
     */
    onActiveFilterClick(event) {
      event.preventDefault();
      this.renderPage(new URL(event.currentTarget.href).searchParams.toString());
    }

    /**
     * onHistoryChange
     * @param {Object} event
     */
    onHistoryChange(event) {
      const searchParams = event.state?.searchParams || '';
      this.renderPage(searchParams, null, false);
    }

    /**
     * renderPage
     * @param {String} searchParams
     * @param {Object} event
     * @param {Boolean} updateURLHash
     */
    renderPage(searchParams, event, updateURLHash = true, filterList = {}) {
      const sections = this.getSections();

      this.toggleLoadingState();

      sections.forEach((section) => {
        for (const [key, value] of Object.entries(filterList)) {
          searchParams = `${searchParams}&${key}=${value}`;
        }

        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;

        this.filterData.some(filterDataUrl)
          ? this.renderSectionFromCache(filterDataUrl, event)
          : this.renderSectionFromFetch(url, event);
      });

      if (updateURLHash) this.updateURLHash(searchParams);
    }

    /**
     * renderSectionFromFetch
     * @param {String} url
     * @param {Object} event
     */
    renderSectionFromFetch(url, event) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          this.filterData = [...this.filterData, { html, url }];
          this.renderProductGrid(html);
          this.toggleLoadingState();
        });
    }

    /**
     * renderSectionFromCache
     * @param {String} filterDataUrl
     * @param {Object} event
     */
    renderSectionFromCache(filterDataUrl, event) {
      const html = this.filterData.find(filterDataUrl).html;
      this.renderProductGrid(html);
      this.toggleLoadingState();
    }

    /**
     * renderProductGrid
     * @param {Node} html
     */
    renderProductGrid(html) {
      document.querySelector('[data-collection-product-grid]').innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('[data-collection-product-grid]').innerHTML;
    }

    toggleLoadingState() {
      document.querySelector('[data-collection-product-grid]').classList.toggle('loading');
      document.querySelector('[data-collection-sorting]').classList.toggle('loading');
    }

    /**
     * updateURLHash
     * @param {String} searchParams
     */
    updateURLHash(searchParams) {
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
      );
    }

    /**
     * getSections
     * @returns Array
     */
    getSections() {
      return [
        {
          id: 'main-collection',
          section: document.getElementById('main-collection').dataset.id,
        },
      ];
    }
  }
  customElements.define('collection-sorting', CollectionSorting);
}

if (!customElements.get('sorting-remove')) {
  class OptionRemove extends HTMLElement {
    constructor() {
      super();

      this.querySelector('a').addEventListener('click', (event) => {
        event.preventDefault();
        const form =
          this.closest('collection-sorting') || document.querySelector('collection-sorting');
        form.onActiveFilterClick(event);
        // Reset the inputs
        const resetButton = document.querySelector('[data-sort-by]');
        const defaultValue = resetButton.dataset.sortBy;
        const defaultInput = document.querySelector(`input[value="${defaultValue}"]`);
        defaultInput.checked = true;
      });
    }
  }
  customElements.define('sorting-remove', OptionRemove);
}
